export default __webpack_public_path__ + "static/media/face.81ed821d.jpg";